import * as actionType from './actionType';
import * as loginApi from '../api/loginApi';

export const verifyPhoneNumber = (params) => ({
  type: actionType.VERIFY_PHONE_NUMBER,
  payload: loginApi.verifyPhoneNumber(params),
});
export const login = (params) => ({
  type: actionType.LOGIN,
  payload: loginApi.login(params),
});

export const verifyOTP = (params) => ({
  type: actionType.VERIFY_OTP,
  payload: loginApi.verifyOTP(params),
});
export const resendOTP = (params) => ({
  type: actionType.RESEND_OTP,
  payload: loginApi.resendOTP(params),
});
export const confirmLoggedIn = () => ({
  type: actionType.CONFIRM_LOGGED_IN,
  payload: loginApi.confirmLoggedIn(),
});
export const logOut = () => ({
  type: actionType.LOG_OUT,
});
